import { GPTGameButton } from './GPTGameButton';
import { GptGameButtonProps } from '../types';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';
import { PigeonEventIcon } from './GPTEventIcons/PigeonEventIcon';

export const LuckyPigeonButton = ({ isCollapsed, isEventActive }: GptGameButtonProps) => {
  return (
    <GPTGameLauncher
      gameName="birdGame"
      renderButton={({ Icon, ...props }) => (
        <GPTGameButton
          {...props}
          Icon={isEventActive ? PigeonEventIcon : Icon}
          isCompact={isCollapsed}
        />
      )}
      authOnly={false}
    />
  );
};
